import _ from 'lodash'
import { STABLE_EMPTY_ARRAY } from '@feedyou/utils'
import { createSelector } from 'reselect'

import { endpointHelpers } from '../endpointHelpers'
import { BotMetadata } from '@feedyou/schema'
import { RootState } from '../../../reducers'

export const botMetadataForEnvironmentGroupSelector = _.memoize(
  (environmentGroupId: string | null | undefined) => {
    return createSelector(
      (state: RootState) => endpointHelpers.getBotsMetadata.selectData()(state)?.metadata,
      (allMetadata: BotMetadata[] = STABLE_EMPTY_ARRAY): BotMetadata[] => {
        if (!environmentGroupId) {
          return []
        }

        return allMetadata?.filter(metadata => metadata.environmentGroupId === environmentGroupId)
      }
    )
  }
)
